import { useEffect, useState } from "react";
import { TrendingUp, DollarSign, Percent, RefreshCw, Tag, Package, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

const money = (n) => `$${(Number(n) || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`;

export default function RetailDashboard() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/retail/dashboard").then((r) => setD(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  if (loading) return <div className="py-16 flex justify-center text-navy/40"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  const k = d?.kpis || {}, promo = d?.promo || {}, trend = d?.trend || [];
  const maxT = Math.max(1, ...trend.map((t) => t.ventas));
  const cards = [
    ["Ventas totales", money(k.ventas), DollarSign, "text-violet"],
    ["Margen", money(k.margen), TrendingUp, "text-emerald-600"],
    ["% Margen", `${k.margen_pct || 0}%`, Percent, "text-navy"],
    ["Ticket promedio", money(k.ticket_promedio), Tag, "text-navy"],
    ["Rotación inv.", `${k.rotacion || 0}×`, RefreshCw, "text-amber-600"],
    ["Piezas vendidas", (k.piezas || 0).toLocaleString("es-MX"), Package, "text-navy"],
  ];

  return (
    <div data-testid="retail-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
        {cards.map(([l, v, Icon, c]) => (
          <div key={l} className="card-surface p-4" data-testid={`rdash-kpi-${l}`}>
            <Icon className={`w-4 h-4 mb-2 ${c}`} />
            <div className="text-xl font-medium">{v}</div>
            <div className="text-[11px] text-navy/40 mt-0.5">{l}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        {/* Trend */}
        <div className="card-surface p-5">
          <div className="overline text-navy/40 mb-4">Ventas · últimos 14 días</div>
          <div className="flex items-end gap-1.5 h-40">
            {trend.map((t) => (
              <div key={t.fecha} className="flex-1 flex flex-col items-center gap-1 group" title={`${t.fecha}: ${money(t.ventas)}`}>
                <div className="w-full rounded-t bg-gradient-violet transition-all" style={{ height: `${Math.max((t.ventas / maxT) * 100, 2)}%` }} />
                <span className="text-[9px] text-navy/30">{t.fecha.slice(8)}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Promo effectiveness + top */}
        <div className="space-y-4">
          <div className="card-surface p-5" data-testid="rdash-promo">
            <div className="overline text-navy/40 mb-3">Efectividad de promociones</div>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div><div className="text-lg font-medium">{promo.pct_tickets || 0}%</div><div className="text-[11px] text-navy/40">tickets con promo</div></div>
              <div><div className="text-lg font-medium text-emerald-600">{money(promo.descuento_otorgado)}</div><div className="text-[11px] text-navy/40">descuento otorgado</div></div>
              <div><div className="text-lg font-medium">{promo.tickets_con_promo || 0}</div><div className="text-[11px] text-navy/40">tickets promocionados</div></div>
              <div><div className="text-lg font-medium">{money(promo.ventas_con_promo)}</div><div className="text-[11px] text-navy/40">venta con promo</div></div>
            </div>
          </div>
          <div className="card-surface p-5" data-testid="rdash-top">
            <div className="overline text-navy/40 mb-2">Top productos</div>
            {(d?.top_productos || []).length === 0 ? <div className="text-sm text-navy/40 py-3">Sin ventas aún.</div> : (
              <div className="space-y-1.5">
                {d.top_productos.map((p) => (
                  <div key={p.sku} className="flex justify-between text-sm border-b border-navy/5 pb-1"><span className="truncate">{p.descripcion} <span className="text-navy/30">×{p.vendidas}</span></span><span className="font-medium">{money(p.importe)}</span></div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
